import { apiSlice } from '../../../store/api/apiSlice';
import type { AdminCalendarViewRequest, AdminCalendarViewResponse } from '../types';

export const adminCalendarViewApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdminCalendarView: builder.query<AdminCalendarViewResponse, AdminCalendarViewRequest>({
      query: ({ personId, start, end }) => ({
        url: `/admin/calendar/view/${encodeURIComponent(personId)}`,
        params: { start, end },
      }),
      providesTags: ['CalendarSettings', 'Sessions', 'Appointments'],
    }),
  }),
});

export const { useGetAdminCalendarViewQuery, useLazyGetAdminCalendarViewQuery } =
  adminCalendarViewApi;
